import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export function Loading() {
  const { t, i18n } = useTranslation('common')
  const [tipIndex, setTipIndex] = useState(0)
  const tips = [
    t('loadingTips.0'),
    t('loadingTips.1'),
    t('loadingTips.2'),
  ]

  useEffect(() => {
    const id = setInterval(() => {
      setTipIndex((i) => (i + 1) % tips.length)
    }, 2200)
    return () => clearInterval(id)
  }, [tips.length, i18n.language])

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={t('loadingAria')}
      className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-white to-slate-100"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute -top-32 -left-32 h-[28rem] w-[28rem] rounded-full bg-indigo-200/55 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-40 -right-32 h-[32rem] w-[32rem] rounded-full bg-rose-200/55 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute top-1/3 right-1/4 h-72 w-72 rounded-full bg-amber-200/45 blur-3xl"
      />

      <div className="relative z-10 flex flex-col items-center gap-7 px-6 text-center">
        <div className="relative h-28 w-28">
          <span
            aria-hidden
            className="absolute inset-0 rounded-full border-[3px] border-transparent animate-spin"
            style={{ borderTopColor: "#6366f1", borderRightColor: "#6366f1", animationDuration: "1.4s" }}
          />
          <span
            aria-hidden
            className="absolute inset-2 rounded-full border-[3px] border-transparent animate-spin"
            style={{ borderBottomColor: "#f43f5e", borderLeftColor: "#f43f5e", animationDuration: "1.8s", animationDirection: "reverse" }}
          />
          <span
            aria-hidden
            className="absolute inset-5 rounded-full border-[3px] border-transparent animate-spin"
            style={{ borderTopColor: "#f59e0b", borderRightColor: "#f59e0b", animationDuration: "2.2s" }}
          />
          <span
            aria-hidden
            className="absolute inset-[2.25rem] rounded-full bg-white shadow-md shadow-slate-900/10 animate-pulse"
          />
        </div>

        <div className="flex items-end gap-2 text-base font-semibold tracking-tight text-slate-700">
          <span>{t('loading')}</span>
          <span className="flex items-end gap-1 pb-[0.35rem]">
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                className="inline-block h-1.5 w-1.5 rounded-full bg-slate-700 animate-bounce"
                style={{ animationDelay: `${i * 0.18}s` }}
              />
            ))}
          </span>
        </div>

        <div className="relative h-5 w-64 overflow-hidden">
          <p
            key={`${i18n.language}-${tipIndex}`}
            className="absolute inset-0 text-xs font-medium text-slate-500"
          >
            {tips[tipIndex]}
          </p>
        </div>
      </div>

      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[3px] overflow-hidden bg-slate-200/70">
        <div className="h-full w-1/3 rounded-r-full bg-gradient-to-r from-indigo-500 via-rose-400 to-amber-400 animate-pulse" />
      </div>

      <span className="sr-only">{t('loadingPleaseWait')}</span>
    </div>
  )
}
